(function () {
  const main = document.getElementById("ins-pdp-main");
  document.querySelectorAll(".ins-thumb").forEach((t) =>
    t.addEventListener("click", () => {
      if (main) main.src = t.dataset.img;
      document.querySelectorAll(".ins-thumb").forEach((x) => x.classList.toggle("is-active", x === t));
    })
  );

  const add = document.getElementById("ins-add");
  const sticky = document.getElementById("ins-sticky");
  const sAdd = document.getElementById("ins-sticky-add");

  // Variant selector (e.g. gift-card amount): update hidden id, price + add-button label.
  const idInput = document.querySelector('#ins-product-form input[name="id"]');
  const priceEl = document.querySelector(".ins-pdp__price");
  const stickyPrice = document.querySelector(".ins-sticky__price");
  document.querySelectorAll(".ins-varbtn").forEach((btn) =>
    btn.addEventListener("click", () => {
      document.querySelectorAll(".ins-varbtn").forEach((x) => x.classList.remove("is-active"));
      btn.classList.add("is-active");
      if (idInput) idInput.value = btn.dataset.vid;
      if (priceEl) priceEl.textContent = btn.dataset.price;
      if (stickyPrice) stickyPrice.textContent = btn.dataset.price;
      var T = (window.INS_I18N && window.INS_I18N.pdp) || {};
      if (add && !btn.dataset.soldout) {
        add.disabled = false;
        add.textContent = (T.add_to_cart || "In winkelmand") + " · " + btn.dataset.price;
      } else if (add && btn.dataset.soldout) {
        add.disabled = true;
        add.textContent = T.sold_out || "Uitverkocht";
      }
    })
  );
  // Description read-more: show the toggle only when the text is actually clamped.
  document.querySelectorAll(".ins-pdp__desc-wrap").forEach((wrap) => {
    const desc = wrap.querySelector(".ins-pdp__desc");
    const btn = wrap.querySelector(".ins-pdp__more");
    const label = wrap.querySelector(".ins-pdp__more-label");
    if (!desc || !btn) return;
    if (desc.scrollHeight - desc.clientHeight > 4) btn.classList.add("is-visible");
    btn.addEventListener("click", () => {
      const open = wrap.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
      if (label) label.textContent = open ? label.dataset.less : label.dataset.more;
    });
  });

  if (sAdd && add) sAdd.addEventListener("click", () => add.click());
  if (add && sticky) {
    // Show the bar only once the main add button has scrolled up out of view, never before the
    // buyer has reached it, so on a phone it does not cover the title on load (board N215, S8).
    // A scroll check rather than an observer: a jump past the button (anchor, fling) never
    // crosses it, so an observer would not fire.
    let queued = false;
    const update = () => { queued = false; sticky.classList.toggle("show", add.getBoundingClientRect().bottom < 0); };
    window.addEventListener("scroll", () => { if (!queued) { queued = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
})();

// AJAX add-to-cart -> open the cart drawer instead of navigating to /cart.
// Falls back to a normal submit (/cart) if the drawer isn't present.
(function () {
  const form = document.getElementById("ins-product-form");
  if (!form) return;
  const addBtn = document.getElementById("ins-add");
  form.addEventListener("submit", async (e) => {
    // Resolve the drawer at submit time (custom elements may upgrade after this
    // script runs). If it isn't available, let the form submit natively to /cart.
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || typeof drawer.renderContents !== "function") return;
    e.preventDefault();
    if (addBtn) { addBtn.classList.add("is-loading"); addBtn.setAttribute("aria-busy", "true"); }
    const fd = new FormData(form);
    try {
      fd.append("sections", drawer.getSectionsToRender().map((s) => s.id).join(","));
      fd.append("sections_url", window.location.pathname);
    } catch (_) {}
    try {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, body: fd });
      const data = await res.json();
      if (data.status) { if (addBtn) { addBtn.classList.remove("is-loading"); addBtn.removeAttribute("aria-busy"); } return; }
      if (drawer.classList.contains("is-empty")) drawer.classList.remove("is-empty");
      drawer.renderContents(data);
      if (!drawer.classList.contains("active") && typeof drawer.open === "function") drawer.open();
    } catch (_) { window.location = "/cart"; return; }
    if (addBtn) { addBtn.classList.remove("is-loading"); addBtn.removeAttribute("aria-busy"); }
  });
})();
